<div class="{{styleBreadcrumb}}">
  <div class="row">
    <div [ngClass]="{'col-10': isFhir, 'col-12': !isFhir}">
      <h1><i *ngIf="icon" class="fal {{icon}} mr-3" style="color: white"></i>{{title}}
        <i *ngIf="breadcrumb" class="fal fa-angle-right"></i>
        <span *ngIf="isStringLiteral && breadcrumb">&nbsp;{{ breadcrumb }}&nbsp;</span>
        <span *ngIf="!isStringLiteral && breadcrumb">&nbsp;{{ breadcrumb | translate }}&nbsp;</span>
        <span *ngIf="dob && isValidDate(dob)" class="date-of-birth">{{dob | date}}<ng-container *ngIf="(dob | age) !== ''"> ({{'AGE' | translate}} {{ dob | age }})</ng-container></span>
        <span *ngIf="count" class="badge badge-pill badge-secondary ml-2"
          [ngStyle]="{'background-color': countBgColor}"><span class="count">{{count}}</span></span>
      </h1>
    </div>    
    <div *ngIf="isFhir" class="col-2 text-right" style="margin-top:20px">
      <button *ngIf="!clientRegistrationRequestSent && !clientFound" class="btn btn-outline-light mr-2" (click)="registerClientClick()">
        {{ 'REGISTER-IN-APPLICATION' | translate:applicationName}}
      </button>
      <button *ngIf="isShowHome" class="btn btn-outline-light mr-4" (click)="openFullSite()">
        {{ 'OPEN-FULL-SITE' | translate }}
        <i class="arrow fal fa-external-link"></i>
      </button>
    </div>
  </div>
</div>